'use strict'

class LoadingOverlay {
    constructor() {
        this.overlay = null;
    }

    init() {
        this.overlay = document.querySelector('.tps-loading-overlay');
    }

    show() {
		this.overlay.classList.remove('hide');
	}

	hide() {
		this.overlay.classList.add('hide');
	}
}
